import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { logoutAction } from "../../Redux/Actions/auth";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ConfirmationModal from "../CommanModals/ConfirmationModal";
import { ChatContext } from "../context/ChatProvider";
import { useSelector } from "react-redux";
import { getNotificationList } from "../../Redux/Actions/NotificationActions";

export default function Sidebar({ show1, unread }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const { unreadCount } = useContext(ChatContext);
  const [notifications, setNotifications] = useState([]);
  const getNotificationlist = useSelector((e) => e.notification.notificationList);


  const isHref = (...paths) => {
    const currentPath = window.location.pathname;
    return paths.some((path) => currentPath.includes(path));
  };

  const handleSignOut = async (e) => {
    e.preventDefault();

    await dispatch(logoutAction())
      .then((res) => {
        if (res?.payload?.statusCode === 200) {
          toast.success(res?.payload?.message);
          cookies.remove("adminToken");
          sessionStorage.removeItem("adminToken");
          sessionStorage.removeItem("fullPermission");
          sessionStorage.removeItem("readOnlyPermission");
          navigate("/");
        }
      })
      .catch((error) => {
        console.error("Logout Error:", error);
      });
  };

  const handleLogout = () => { };

  useEffect(() => {
    if (getNotificationlist && getNotificationlist.length > 0) {
      //  dispatch(getNotificationList());
      setNotifications(
        getNotificationlist.map((item) => ({
          ...item,
          is_changes_request: !item.is_changes_request || false,
          is_song_request: !item.is_song_request || false,
        }))
      );
    } else {
      setNotifications([]);
    }
  }, [getNotificationlist]);
  
  useEffect(() => {
 dispatch(getNotificationList());
  },[])

const hasSongRequest = notifications.some((n) => n.is_song_request && n.notificationType === "SongRequest");
const hasChangeRequest = notifications.some((n) => n.is_changes_request && n.notificationType === "request_change");

  return (
    <aside className={show1 ? `moving-sidebar` : "sidebar-left-move"}>
      <div className="sidebar">
        <div className="logo-side">
          <Link to="/clients">
            <img
              className="big"
              src={require("../../Assets/Images/side-bar-logo.svg").default}
            />
          </Link>
        </div>
        <div className="side-menu">
          <div>
            <hr className="bg-light text-light" />
            <div className="side-btm-space">
              <Link
                // className={
                //   window.location.pathname == "/clients"
                //     ? "menu-btn bar_active"
                //     : "menu-btn "
                // }
                className={
                  isHref("clients", "client")
                    ? "menu-btn bar_active"
                    : "menu-btn"
                }
                to={`/clients?page=0`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.4819 9.72178C12.6611 9.72178 11.8907 9.88739 11.2427 10.1682C13.5107 10.8234 15.1163 12.393 15.1595 14.229C16.3403 14.0778 17.6147 13.6314 17.6147 12.4146C17.6147 10.953 15.7211 9.72178 13.4819 9.72178ZM13.4603 8.68498H13.4747C15.0083 8.68498 16.2611 7.43218 16.2611 5.90578C16.2592 5.16737 15.9651 4.45974 15.4429 3.9376C14.9208 3.41546 14.2132 3.12129 13.4747 3.11938C13.1723 3.11938 12.8843 3.16978 12.6107 3.25618C13.1249 4.01724 13.3984 4.91532 13.3955 5.83378C13.4044 6.79869 13.1014 7.74064 12.5315 8.51938C12.8267 8.62738 13.1363 8.68498 13.4603 8.68498ZM6.38995 10.161C5.74195 9.88738 4.97155 9.72178 4.15795 9.72178C1.91875 9.72178 0.0251465 10.953 0.0251465 12.4146C0.0251465 13.6314 1.29235 14.0706 2.47315 14.229C2.50915 12.393 4.11475 10.8234 6.38995 10.161ZM4.15795 8.68498H4.17955C4.50355 8.68498 4.81315 8.62738 5.10835 8.51938C4.53964 7.73966 4.23446 6.79887 4.23715 5.83378C4.23715 4.87618 4.52515 3.99058 5.02195 3.25618C4.74835 3.16978 4.46035 3.11938 4.15795 3.11938C3.4202 3.12129 2.71331 3.4157 2.19232 3.93804C1.67132 4.46039 1.37874 5.16803 1.37875 5.90578C1.37875 7.43218 2.62435 8.68498 4.15795 8.68498Z"
                    fill="#132027"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.81645 10.9004C5.96453 10.9004 3.55469 12.4527 3.55469 14.2902C3.55469 16.6662 7.51469 16.6662 8.81645 16.6662C11.0758 16.6662 14.0796 16.4214 14.0796 14.3053C14.0796 12.4592 11.6691 10.9004 8.81645 10.9004ZM8.81645 9.3373H8.84093C9.29935 9.33707 9.75316 9.24588 10.1761 9.06902C10.599 8.89216 10.9826 8.63315 11.3048 8.30698C11.6288 7.98277 11.8852 7.59748 12.0593 7.17343C12.2333 6.74939 12.3214 6.29502 12.3185 5.83666C12.3176 4.90808 11.9483 4.01779 11.2918 3.36112C10.6352 2.70444 9.74503 2.33501 8.81645 2.33386C7.88806 2.3352 6.9981 2.70474 6.34183 3.36141C5.68556 4.01809 5.31657 4.90827 5.31581 5.83666C5.31695 6.76474 5.68613 7.65448 6.34238 8.31073C6.99863 8.96698 7.88837 9.33616 8.81645 9.3373Z"
                    fill="#132027"
                  />
                </svg>

                <p> Clients</p>
              </Link>
            </div>

            <div className="side-btm-space">
              <Link
                className={
                  isHref("events", "events-details")
                    ? "menu-btn bar_active"
                    : "menu-btn"
                }
                // className={
                //   window.location.pathname == "/events"
                //     ? "menu-btn bar_active"
                //     : "menu-btn "
                // }
                to="/events"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <g clip-path="url(#clip0_70_8692)">
                    <path
                      d="M0 8V14.75C0 16.8177 1.68225 18.5 3.75 18.5H14.25C16.3177 18.5 18 16.8177 18 14.75V8H0ZM0 6.5V5.75C0 3.68225 1.68225 2 3.75 2H4.5V1.25C4.5 1.05109 4.57902 0.860322 4.71967 0.71967C4.86032 0.579018 5.05109 0.5 5.25 0.5C5.44891 0.5 5.63968 0.579018 5.78033 0.71967C5.92098 0.860322 6 1.05109 6 1.25V2H12V1.25C12 1.05109 12.079 0.860322 12.2197 0.71967C12.3603 0.579018 12.5511 0.5 12.75 0.5C12.9489 0.5 13.1397 0.579018 13.2803 0.71967C13.421 0.860322 13.5 1.05109 13.5 1.25V2H14.25C16.3177 2 18 3.68225 18 5.75V6.5H0Z"
                      fill="#979699"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_70_8692">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <p>Calendar</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/transactions"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/transactions"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="13"
                  viewBox="0 0 18 13"
                  fill="none"
                >
                  <path
                    d="M17.7604 4.28518L14.4877 1.01239C14.3333 0.863351 14.1267 0.780882 13.9121 0.782746C13.6976 0.78461 13.4924 0.870659 13.3407 1.02236C13.189 1.17406 13.1029 1.37927 13.1011 1.5938C13.0992 1.80833 13.1817 2.01501 13.3307 2.16932L15.2068 4.04545H4.09081C3.87381 4.04545 3.6657 4.13165 3.51226 4.2851C3.35882 4.43854 3.27262 4.64665 3.27262 4.86365C3.27262 5.08065 3.35882 5.28876 3.51226 5.4422C3.6657 5.59564 3.87381 5.68185 4.09081 5.68185H17.182C17.3438 5.68181 17.5019 5.63381 17.6365 5.5439C17.771 5.45399 17.8758 5.32622 17.9377 5.17674C17.9996 5.02725 18.0158 4.86277 17.9843 4.70407C17.9527 4.54538 17.8748 4.39961 17.7604 4.28518ZM13.9092 7.31824H0.818024C0.656225 7.31828 0.498068 7.36628 0.363549 7.45619C0.229029 7.5461 0.124185 7.67387 0.0622723 7.82335C0.000359289 7.97284 -0.0158437 8.13732 0.0157122 8.29601C0.0472681 8.45471 0.125166 8.60048 0.239558 8.71491L3.51235 11.9877C3.66666 12.1367 3.87334 12.2192 4.08787 12.2173C4.3024 12.2155 4.50761 12.1294 4.65931 11.9777C4.81101 11.826 4.89706 11.6208 4.89893 11.4063C4.90079 11.1918 4.81832 10.9851 4.66928 10.8308L2.79315 8.95464H13.9092C14.1262 8.95464 14.3343 8.86843 14.4877 8.71499C14.6412 8.56155 14.7274 8.35344 14.7274 8.13644C14.7274 7.91944 14.6412 7.71133 14.4877 7.55789C14.3343 7.40444 14.1262 7.31824 13.9092 7.31824Z"
                    fill="#979699"
                  />
                </svg>

                <p>Transactions</p>
              </Link>
            </div>

            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/messages"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/messages"
              >
                <div style={{ position: 'relative' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_70_8765)">
                      <path
                        d="M14.755 2.56858C13.8047 1.77782 12.701 1.19245 11.5133 0.849351C10.3256 0.506254 9.07976 0.412868 7.85421 0.575077C5.58701 0.869615 3.51688 2.01596 2.06416 3.78133C0.611432 5.54671 -0.114983 7.79879 0.0324073 10.0803C0.179798 12.3618 1.18995 14.5017 2.85774 16.0655C4.52554 17.6293 6.72596 18.4997 9.01221 18.5001H14.2487C15.2429 18.4989 16.196 18.1034 16.899 17.4004C17.6021 16.6974 17.9975 15.7443 17.9987 14.7501V8.93458C17.9193 7.70866 17.5907 6.51182 17.033 5.41724C16.4753 4.32266 15.7001 3.35335 14.755 2.56858ZM5.99871 5.75008H8.99871C9.19763 5.75008 9.38839 5.82909 9.52904 5.96975C9.6697 6.1104 9.74871 6.30116 9.74871 6.50008C9.74871 6.69899 9.6697 6.88975 9.52904 7.03041C9.38839 7.17106 9.19763 7.25008 8.99871 7.25008H5.99871C5.7998 7.25008 5.60904 7.17106 5.46838 7.03041C5.32773 6.88975 5.24871 6.69899 5.24871 6.50008C5.24871 6.30116 5.32773 6.1104 5.46838 5.96975C5.60904 5.82909 5.7998 5.75008 5.99871 5.75008ZM11.9987 13.2501H5.99871C5.7998 13.2501 5.60904 13.1711 5.46838 13.0304C5.32773 12.8898 5.24871 12.699 5.24871 12.5001C5.24871 12.3012 5.32773 12.1104 5.46838 11.9697C5.60904 11.8291 5.7998 11.7501 5.99871 11.7501H11.9987C12.1976 11.7501 12.3884 11.8291 12.529 11.9697C12.6697 12.1104 12.7487 12.3012 12.7487 12.5001C12.7487 12.699 12.6697 12.8898 12.529 13.0304C12.3884 13.1711 12.1976 13.2501 11.9987 13.2501ZM11.9987 10.2501H5.99871C5.7998 10.2501 5.60904 10.1711 5.46838 10.0304C5.32773 9.88976 5.24871 9.69899 5.24871 9.50008C5.24871 9.30116 5.32773 9.1104 5.46838 8.96975C5.60904 8.82909 5.7998 8.75008 5.99871 8.75008H11.9987C12.1976 8.75008 12.3884 8.82909 12.529 8.96975C12.6697 9.1104 12.7487 9.30116 12.7487 9.50008C12.7487 9.69899 12.6697 9.88976 12.529 10.0304C12.3884 10.1711 12.1976 10.2501 11.9987 10.2501Z"
                        fill="#132027"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_70_8765">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  {unreadCount > 0 && (
                    <span
                      style={{
                        position: 'absolute',
                        top: '-1px',
                        right: '11px',
                        width: '8px',
                        height: '8px',
                        backgroundColor: 'red',
                        borderRadius: '50%',
                      }}
                    />
                  )}
                </div>
                <p>Messages</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/songs"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/songs"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="19"
                  viewBox="0 0 14 19"
                  fill="none"
                >
                  <path
                    d="M12.2243 11.9474C12.7838 11.0113 13.1549 9.82739 13.2269 8.6559C13.2726 7.90399 13.105 7.11469 12.7422 6.37247C12.1731 5.20652 11.1955 4.55154 10.2511 3.91871C9.54625 3.44652 8.88019 3.00063 8.40938 2.36365L8.32491 2.2501C8.04658 1.87622 7.73224 1.45249 7.68239 1.09662C7.63254 0.736583 7.30575 0.480407 6.94848 0.501178C6.7737 0.513001 6.60995 0.590815 6.49039 0.718857C6.37083 0.846899 6.30441 1.0156 6.30458 1.19078V13.5288C5.72437 13.1771 5.00985 12.9611 4.22747 12.9611C2.3193 12.9611 0.765625 14.2032 0.765625 15.7305C0.765625 17.2579 2.3193 18.5 4.22747 18.5C6.13564 18.5 7.68932 17.2579 7.68932 15.7305V7.66028C8.72926 8.0577 10.4311 9.06994 10.8991 11.4337C10.8119 11.5625 10.7288 11.7009 10.6319 11.8117C10.3785 12.0984 10.4062 12.5359 10.6942 12.788C10.9795 13.0428 11.417 13.0123 11.6704 12.7257C11.856 12.5152 12.0208 12.2687 12.1786 12.0111C12.1953 11.9917 12.2105 11.971 12.2243 11.9474Z"
                    fill="#979699"
                  />
                </svg>
                <p>Songs</p>
              </Link>
            </div>

            {/* song request */}
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/songrequest"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/songrequest"
              >
                <div style={{ position: 'relative' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >

                    <path
                      d="M12.2243 11.9474C12.7838 11.0113 13.1549 9.82739 13.2269 8.6559C13.2726 7.90399 13.105 7.11469 12.7422 6.37247C12.1731 5.20652 11.1955 4.55154 10.2511 3.91871C9.54625 3.44652 8.88019 3.00063 8.40938 2.36365L8.32491 2.2501C8.04658 1.87622 7.73224 1.45249 7.68239 1.09662C7.63254 0.736583 7.30575 0.480407 6.94848 0.501178C6.7737 0.513001 6.60995 0.590815 6.49039 0.718857C6.37083 0.846899 6.30441 1.0156 6.30458 1.19078V13.5288C5.72437 13.1771 5.00985 12.9611 4.22747 12.9611C2.3193 12.9611 0.765625 14.2032 0.765625 15.7305C0.765625 17.2579 2.3193 18.5 4.22747 18.5C6.13564 18.5 7.68932 17.2579 7.68932 15.7305V7.66028C8.72926 8.0577 10.4311 9.06994 10.8991 11.4337C10.8119 11.5625 10.7288 11.7009 10.6319 11.8117C10.3785 12.0984 10.4062 12.5359 10.6942 12.788C10.9795 13.0428 11.417 13.0123 11.6704 12.7257C11.856 12.5152 12.0208 12.2687 12.1786 12.0111C12.1953 11.9917 12.2105 11.971 12.2243 11.9474Z"
                      fill="#979699"
                    />

                    <path
                      d="M13 5.5H16C16.5523 5.5 17 5.94772 17 6.5V9.5C17 10.0523 16.5523 10.5 16 10.5H13C12.4477 10.5 12 10.0523 12 9.5V7.5L13 6.5Z"
                      stroke="#979699"
                      stroke-width="1"
                    />
                  </svg>
                  {hasSongRequest && (
                    <span
                      style={{
                        position: 'absolute',
                        top: '-1px',
                        right: '11px',
                        width: '8px',
                        height: '8px',
                        backgroundColor: 'red',
                        borderRadius: '50%',
                      }}
                    />
                  )}
                </div>
                <p>Song Requests</p>
              </Link>
            </div>


            {/*  request change */}
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/requestchanges"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/requestchanges"
              >
           <div style={{ position: 'relative' }}>
                  <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z"
                    fill="#979699"
                  />
                  <path
                    d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25Z"
                    stroke="#979699"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                  {hasChangeRequest && (
                    <span
                      style={{
                        position: 'absolute',
                        top: '-1px',
                        right: '11px',
                        width: '8px',
                        height: '8px',
                        backgroundColor: 'red',
                        borderRadius: '50%',
                      }}
                    />
                  )}
                  </div>
                <p>Change Requests</p>
              </Link>
            </div>

            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/administrators"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/administrators"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <g clip-path="url(#clip0_79_6611)">
                    <path
                      d="M9 9.5C11.4853 9.5 13.5 7.48528 13.5 5C13.5 2.51472 11.4853 0.5 9 0.5C6.51472 0.5 4.5 2.51472 4.5 5C4.5 7.48528 6.51472 9.5 9 9.5Z"
                      fill="#979699"
                    />
                    <path
                      d="M9 11C5.27379 11.0041 2.25415 14.0238 2.25 17.75C2.25 18.1642 2.58578 18.5 2.99999 18.5H15C15.4142 18.5 15.75 18.1642 15.75 17.75C15.7459 14.0238 12.7262 11.0041 9 11Z"
                      fill="#979699"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_79_6611">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p>Administrators</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/resources"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/resources"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <g clip-path="url(#clip0_382_790)">
                    <path
                      d="M3.72656 18.5H14.2734C15.1458 18.5 15.8555 17.7903 15.8555 16.918V5.77344H12.1641C11.2917 5.77344 10.582 5.06377 10.582 4.19141V0.5H3.72656C2.8542 0.5 2.14453 1.20966 2.14453 2.08203V16.918C2.14453 17.7903 2.8542 18.5 3.72656 18.5ZM5.83594 7.91797H12.1641C12.4555 7.91797 12.6914 8.15383 12.6914 8.44531C12.6914 8.73679 12.4555 8.97266 12.1641 8.97266H5.83594C5.54446 8.97266 5.30859 8.73679 5.30859 8.44531C5.30859 8.15383 5.54446 7.91797 5.83594 7.91797ZM5.83594 10.0273H12.1641C12.4555 10.0273 12.6914 10.2632 12.6914 10.5547C12.6914 10.8462 12.4555 11.082 12.1641 11.082H5.83594C5.54446 11.082 5.30859 10.8462 5.30859 10.5547C5.30859 10.2632 5.54446 10.0273 5.83594 10.0273ZM5.83594 12.1367H12.1641C12.4555 12.1367 12.6914 12.3726 12.6914 12.6641C12.6914 12.9555 12.4555 13.1914 12.1641 13.1914H5.83594C5.54446 13.1914 5.30859 12.9555 5.30859 12.6641C5.30859 12.3726 5.54446 12.1367 5.83594 12.1367ZM5.83594 14.2461H10.0547C10.3462 14.2461 10.582 14.482 10.582 14.7734C10.582 15.0649 10.3462 15.3008 10.0547 15.3008H5.83594C5.54446 15.3008 5.30859 15.0649 5.30859 14.7734C5.30859 14.482 5.54446 14.2461 5.83594 14.2461Z"
                      fill="#979699"
                    />
                    <path
                      d="M12.1641 4.71872H15.5465L11.6367 0.80896V4.19138C11.6367 4.48233 11.8731 4.71872 12.1641 4.71872Z"
                      fill="#979699"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_382_790">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <p> Resources</p>
              </Link>
            </div>

            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/faqs"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/faqs"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <g clip-path="url(#clip0_382_811)">
                    <path
                      d="M9 0.5C7.21997 0.5 5.47991 1.02784 3.99987 2.01677C2.51983 3.00571 1.36628 4.41131 0.685088 6.05585C0.00389957 7.70038 -0.17433 9.50998 0.172937 11.2558C0.520204 13.0016 1.37737 14.6053 2.63604 15.864C3.89472 17.1226 5.49836 17.9798 7.24419 18.3271C8.99002 18.6743 10.7996 18.4961 12.4442 17.8149C14.0887 17.1337 15.4943 15.9802 16.4832 14.5001C17.4722 13.0201 18 11.28 18 9.5C17.9974 7.11384 17.0484 4.82616 15.3611 3.13889C13.6738 1.45162 11.3862 0.502581 9 0.5ZM9 14.75C8.85167 14.75 8.70666 14.706 8.58333 14.6236C8.45999 14.5412 8.36386 14.4241 8.30709 14.287C8.25033 14.15 8.23548 13.9992 8.26442 13.8537C8.29335 13.7082 8.36479 13.5746 8.46967 13.4697C8.57456 13.3648 8.7082 13.2934 8.85369 13.2644C8.99917 13.2355 9.14997 13.2503 9.28702 13.3071C9.42406 13.3639 9.54119 13.46 9.62361 13.5833C9.70602 13.7067 9.75 13.8517 9.75 14C9.75 14.1989 9.67099 14.3897 9.53033 14.5303C9.38968 14.671 9.19892 14.75 9 14.75ZM10.1453 10.025C10.0224 10.0848 9.91961 10.179 9.84942 10.2962C9.77924 10.4134 9.74469 10.5485 9.75 10.685V11C9.75 11.1989 9.67099 11.3897 9.53033 11.5303C9.38968 11.671 9.19892 11.75 9 11.75C8.80109 11.75 8.61033 11.671 8.46967 11.5303C8.32902 11.3897 8.25 11.1989 8.25 11V10.685C8.24226 10.2508 8.36395 9.82416 8.59956 9.45939C8.83517 9.09461 9.17405 8.80824 9.573 8.63675C9.89149 8.50489 10.1548 8.26736 10.3188 7.96412C10.4827 7.66088 10.5371 7.31044 10.473 6.97175C10.4152 6.67497 10.2702 6.40219 10.0564 6.1884C9.84256 5.9746 9.56979 5.82952 9.273 5.77175C9.0563 5.73164 8.83341 5.73977 8.62021 5.79558C8.407 5.85138 8.20871 5.95347 8.03944 6.09461C7.87016 6.23574 7.73407 6.41243 7.64084 6.61213C7.5476 6.81183 7.49952 7.02961 7.5 7.25C7.5 7.44891 7.42099 7.63968 7.28033 7.78033C7.13968 7.92098 6.94892 8 6.75 8C6.55109 8 6.36033 7.92098 6.21967 7.78033C6.07902 7.63968 6 7.44891 6 7.25C6.0004 6.7067 6.14833 6.17371 6.428 5.70792C6.70767 5.24213 7.10859 4.86103 7.58794 4.6053C8.06729 4.34958 8.60709 4.22883 9.14972 4.25594C9.69234 4.28306 10.2174 4.45701 10.6689 4.75925C11.1204 5.06148 11.4813 5.48065 11.7131 5.972C11.945 6.46335 12.039 7.00843 11.9853 7.54906C11.9315 8.0897 11.732 8.60559 11.4079 9.04165C11.0838 9.47772 10.6474 9.8176 10.1453 10.025Z"
                      fill="#979699"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_382_811">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p>FAQs</p>
              </Link>
            </div>

            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/presets"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/presets"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <g clip-path="url(#clip0_382_825)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.5237 11.0835C15.9586 10.7579 15.6076 10.1514 15.6076 9.5C15.6076 8.84887 15.9586 8.24239 16.5221 7.91716C17.1004 7.58469 17.3409 6.89387 17.0938 6.2747C16.784 5.49257 16.3622 4.76206 15.8433 4.10316C15.4297 3.57856 14.7114 3.44117 14.1331 3.77579C13.5696 4.10316 12.8677 4.10415 12.3026 3.77825C11.7392 3.45235 11.3899 2.84489 11.3915 2.19228C11.3915 1.52466 10.9137 0.970602 10.2531 0.875047C9.42147 0.754699 8.57681 0.755528 7.74544 0.877508C7.0864 0.973731 6.60863 1.52748 6.61025 2.19376C6.61025 2.84556 6.26094 3.45267 5.69749 3.77825C5.13235 4.1038 4.43214 4.10313 3.86704 3.77611C3.28876 3.44149 2.57041 3.57955 2.15687 4.10415C1.8979 4.43337 1.66279 4.78069 1.45335 5.14344C1.2441 5.50576 1.06122 5.88552 0.906358 6.27153C0.657557 6.89169 0.898131 7.58349 1.47642 7.91681C2.04155 8.24204 2.39248 8.84884 2.39248 9.49996C2.39248 10.1511 2.04155 10.7574 1.47807 11.0831C0.899784 11.4156 0.659245 12.1061 0.906358 12.7251C1.21559 13.5058 1.63685 14.2374 2.15687 14.8968C2.57041 15.4214 3.28876 15.5588 3.86704 15.2241C4.43053 14.8968 5.13239 14.8961 5.69749 15.2217C6.26094 15.5476 6.61025 16.155 6.61025 16.8076C6.6086 17.4751 7.08802 18.0292 7.74706 18.1249C8.15901 18.1846 8.57472 18.2145 8.99096 18.2145C9.41276 18.2145 9.83453 18.1839 10.2547 18.1224C10.9137 18.026 11.3915 17.4728 11.3915 16.8065C11.3898 16.1544 11.7391 15.5472 12.3026 15.2217C12.8677 14.8961 13.5679 14.8968 14.133 15.2238C14.7113 15.5584 15.4297 15.4207 15.8432 14.8958C16.102 14.5666 16.3371 14.2194 16.5467 13.8568C16.7543 13.4945 16.9405 13.1147 17.0937 12.7284C17.3426 12.1082 17.102 11.4163 16.5237 11.0835ZM11.2416 10.7945C10.8972 11.3932 10.3387 11.8218 9.66983 12.0007C9.00256 12.1796 8.30397 12.0879 7.70589 11.7418C6.47022 11.0281 6.04515 9.44199 6.75854 8.20548C7.23635 7.37607 8.10956 6.9118 9.00418 6.9118C9.44409 6.9118 9.8873 7.02317 10.2942 7.25812C11.5299 7.97169 11.955 9.55829 11.2416 10.7945Z"
                      fill="#979699"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_382_825">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p>Event Presets</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/event-packages"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/event-packages"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <g clip-path="url(#clip0_382_825)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.5237 11.0835C15.9586 10.7579 15.6076 10.1514 15.6076 9.5C15.6076 8.84887 15.9586 8.24239 16.5221 7.91716C17.1004 7.58469 17.3409 6.89387 17.0938 6.2747C16.784 5.49257 16.3622 4.76206 15.8433 4.10316C15.4297 3.57856 14.7114 3.44117 14.1331 3.77579C13.5696 4.10316 12.8677 4.10415 12.3026 3.77825C11.7392 3.45235 11.3899 2.84489 11.3915 2.19228C11.3915 1.52466 10.9137 0.970602 10.2531 0.875047C9.42147 0.754699 8.57681 0.755528 7.74544 0.877508C7.0864 0.973731 6.60863 1.52748 6.61025 2.19376C6.61025 2.84556 6.26094 3.45267 5.69749 3.77825C5.13235 4.1038 4.43214 4.10313 3.86704 3.77611C3.28876 3.44149 2.57041 3.57955 2.15687 4.10415C1.8979 4.43337 1.66279 4.78069 1.45335 5.14344C1.2441 5.50576 1.06122 5.88552 0.906358 6.27153C0.657557 6.89169 0.898131 7.58349 1.47642 7.91681C2.04155 8.24204 2.39248 8.84884 2.39248 9.49996C2.39248 10.1511 2.04155 10.7574 1.47807 11.0831C0.899784 11.4156 0.659245 12.1061 0.906358 12.7251C1.21559 13.5058 1.63685 14.2374 2.15687 14.8968C2.57041 15.4214 3.28876 15.5588 3.86704 15.2241C4.43053 14.8968 5.13239 14.8961 5.69749 15.2217C6.26094 15.5476 6.61025 16.155 6.61025 16.8076C6.6086 17.4751 7.08802 18.0292 7.74706 18.1249C8.15901 18.1846 8.57472 18.2145 8.99096 18.2145C9.41276 18.2145 9.83453 18.1839 10.2547 18.1224C10.9137 18.026 11.3915 17.4728 11.3915 16.8065C11.3898 16.1544 11.7391 15.5472 12.3026 15.2217C12.8677 14.8961 13.5679 14.8968 14.133 15.2238C14.7113 15.5584 15.4297 15.4207 15.8432 14.8958C16.102 14.5666 16.3371 14.2194 16.5467 13.8568C16.7543 13.4945 16.9405 13.1147 17.0937 12.7284C17.3426 12.1082 17.102 11.4163 16.5237 11.0835ZM11.2416 10.7945C10.8972 11.3932 10.3387 11.8218 9.66983 12.0007C9.00256 12.1796 8.30397 12.0879 7.70589 11.7418C6.47022 11.0281 6.04515 9.44199 6.75854 8.20548C7.23635 7.37607 8.10956 6.9118 9.00418 6.9118C9.44409 6.9118 9.8873 7.02317 10.2942 7.25812C11.5299 7.97169 11.955 9.55829 11.2416 10.7945Z"
                      fill="#979699"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_382_825">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p>Event Packages</p>
              </Link>
            </div>
            {/* register user sidebar */}
            <div className="side-btm-space">
              <Link
                // className={
                //   window.location.pathname == "/clients"
                //     ? "menu-btn bar_active"
                //     : "menu-btn "
                // }
                className={isHref("users") ? "menu-btn bar_active" : "menu-btn"}
                to={`/users?page=0`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.4819 9.72178C12.6611 9.72178 11.8907 9.88739 11.2427 10.1682C13.5107 10.8234 15.1163 12.393 15.1595 14.229C16.3403 14.0778 17.6147 13.6314 17.6147 12.4146C17.6147 10.953 15.7211 9.72178 13.4819 9.72178ZM13.4603 8.68498H13.4747C15.0083 8.68498 16.2611 7.43218 16.2611 5.90578C16.2592 5.16737 15.9651 4.45974 15.4429 3.9376C14.9208 3.41546 14.2132 3.12129 13.4747 3.11938C13.1723 3.11938 12.8843 3.16978 12.6107 3.25618C13.1249 4.01724 13.3984 4.91532 13.3955 5.83378C13.4044 6.79869 13.1014 7.74064 12.5315 8.51938C12.8267 8.62738 13.1363 8.68498 13.4603 8.68498ZM6.38995 10.161C5.74195 9.88738 4.97155 9.72178 4.15795 9.72178C1.91875 9.72178 0.0251465 10.953 0.0251465 12.4146C0.0251465 13.6314 1.29235 14.0706 2.47315 14.229C2.50915 12.393 4.11475 10.8234 6.38995 10.161ZM4.15795 8.68498H4.17955C4.50355 8.68498 4.81315 8.62738 5.10835 8.51938C4.53964 7.73966 4.23446 6.79887 4.23715 5.83378C4.23715 4.87618 4.52515 3.99058 5.02195 3.25618C4.74835 3.16978 4.46035 3.11938 4.15795 3.11938C3.4202 3.12129 2.71331 3.4157 2.19232 3.93804C1.67132 4.46039 1.37874 5.16803 1.37875 5.90578C1.37875 7.43218 2.62435 8.68498 4.15795 8.68498Z"
                    fill="#132027"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.81645 10.9004C5.96453 10.9004 3.55469 12.4527 3.55469 14.2902C3.55469 16.6662 7.51469 16.6662 8.81645 16.6662C11.0758 16.6662 14.0796 16.4214 14.0796 14.3053C14.0796 12.4592 11.6691 10.9004 8.81645 10.9004ZM8.81645 9.3373H8.84093C9.29935 9.33707 9.75316 9.24588 10.1761 9.06902C10.599 8.89216 10.9826 8.63315 11.3048 8.30698C11.6288 7.98277 11.8852 7.59748 12.0593 7.17343C12.2333 6.74939 12.3214 6.29502 12.3185 5.83666C12.3176 4.90808 11.9483 4.01779 11.2918 3.36112C10.6352 2.70444 9.74503 2.33501 8.81645 2.33386C7.88806 2.3352 6.9981 2.70474 6.34183 3.36141C5.68556 4.01809 5.31657 4.90827 5.31581 5.83666C5.31695 6.76474 5.68613 7.65448 6.34238 8.31073C6.99863 8.96698 7.88837 9.33616 8.81645 9.3373Z"
                    fill="#132027"
                  />
                </svg>

                <p> Registered Interest</p>
              </Link>
            </div>

            <div className="side-btm-space">
              <Link
                className={
                  isHref("location") ? "menu-btn bar_active" : "menu-btn"
                }
                to={`/location`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  className="location-pin-icon"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 0C6.243 0 4 2.243 4 5C4 7.761 7.545 13.51 9 15.547C10.455 13.51 14 7.761 14 5C14 2.243 11.757 0 9 0ZM9 7C7.343 7 6 5.657 6 5C6 4.343 7.343 3 9 3C10.657 3 12 4.343 12 5C12 5.657 10.657 7 9 7Z"
                    fill="#132027"
                  />
                </svg>

                <p> Location</p>
              </Link>
            </div>

            {/*  where did u hear */}
            <div className="side-btm-space">
              <Link
                // className={
                //   window.location.pathname == "/clients"
                //     ? "menu-btn bar_active"
                //     : "menu-btn "
                // }
                className={isHref("referralsource") ? "menu-btn bar_active" : "menu-btn"}
                to={`/referralsource`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.4819 9.72178C12.6611 9.72178 11.8907 9.88739 11.2427 10.1682C13.5107 10.8234 15.1163 12.393 15.1595 14.229C16.3403 14.0778 17.6147 13.6314 17.6147 12.4146C17.6147 10.953 15.7211 9.72178 13.4819 9.72178ZM13.4603 8.68498H13.4747C15.0083 8.68498 16.2611 7.43218 16.2611 5.90578C16.2592 5.16737 15.9651 4.45974 15.4429 3.9376C14.9208 3.41546 14.2132 3.12129 13.4747 3.11938C13.1723 3.11938 12.8843 3.16978 12.6107 3.25618C13.1249 4.01724 13.3984 4.91532 13.3955 5.83378C13.4044 6.79869 13.1014 7.74064 12.5315 8.51938C12.8267 8.62738 13.1363 8.68498 13.4603 8.68498ZM6.38995 10.161C5.74195 9.88738 4.97155 9.72178 4.15795 9.72178C1.91875 9.72178 0.0251465 10.953 0.0251465 12.4146C0.0251465 13.6314 1.29235 14.0706 2.47315 14.229C2.50915 12.393 4.11475 10.8234 6.38995 10.161ZM4.15795 8.68498H4.17955C4.50355 8.68498 4.81315 8.62738 5.10835 8.51938C4.53964 7.73966 4.23446 6.79887 4.23715 5.83378C4.23715 4.87618 4.52515 3.99058 5.02195 3.25618C4.74835 3.16978 4.46035 3.11938 4.15795 3.11938C3.4202 3.12129 2.71331 3.4157 2.19232 3.93804C1.67132 4.46039 1.37874 5.16803 1.37875 5.90578C1.37875 7.43218 2.62435 8.68498 4.15795 8.68498Z"
                    fill="#132027"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.81645 10.9004C5.96453 10.9004 3.55469 12.4527 3.55469 14.2902C3.55469 16.6662 7.51469 16.6662 8.81645 16.6662C11.0758 16.6662 14.0796 16.4214 14.0796 14.3053C14.0796 12.4592 11.6691 10.9004 8.81645 10.9004ZM8.81645 9.3373H8.84093C9.29935 9.33707 9.75316 9.24588 10.1761 9.06902C10.599 8.89216 10.9826 8.63315 11.3048 8.30698C11.6288 7.98277 11.8852 7.59748 12.0593 7.17343C12.2333 6.74939 12.3214 6.29502 12.3185 5.83666C12.3176 4.90808 11.9483 4.01779 11.2918 3.36112C10.6352 2.70444 9.74503 2.33501 8.81645 2.33386C7.88806 2.3352 6.9981 2.70474 6.34183 3.36141C5.68556 4.01809 5.31657 4.90827 5.31581 5.83666C5.31695 6.76474 5.68613 7.65448 6.34238 8.31073C6.99863 8.96698 7.88837 9.33616 8.81645 9.3373Z"
                    fill="#132027"
                  />
                </svg>

                <p>Referral Source</p>
              </Link>
            </div>
          </div>

          <div>
            <hr className="bg-light text-light" />
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/"
                    ? "menu-btns bar_active"
                    : "menu-btns "
                }
                onClick={() => setShow(true)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M9.5 0.75H12.5C12.8978 0.75 13.2794 0.908035 13.5607 1.18934C13.842 1.47064 14 1.85218 14 2.25V12.75C14 13.575 13.325 14.25 12.5 14.25H9.5M5 11.25L1.25 7.5L5 3.75M2.15 7.5H10.25"
                    stroke="#979699"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p>Log out</p>
              </Link>
            </div>
          </div>

        </div>
      </div>
      <ConfirmationModal
        handleClose={handleClose}
        show={show}
        handleSubmit={handleSignOut}
        message={"Are you sure you want to log out ?"}
      />
    </aside>
  );
}
